import { LendVaultActivityRequestApi } from "../../types/api/lend-vault-activity";
import { LendVaultActivityItem } from "../../types/domain/lend-vault-activity";
import { VaultActionType } from "../../types/vault";
import { useLendVaultActivityDomain } from "../domain/lend-vault-activity";

export function useLendVaultActivity(params: LendVaultActivityRequestApi | undefined) {
    const domain = useLendVaultActivityDomain(params);
    return {
        data: domain.data,
        isLoading: domain.isLoading,
        isFetching: domain.isFetching
    };
}

export type LendVaultActivityItemWithContribution = LendVaultActivityItem & { contribution: bigint };

// Cumulative net deposits (deposits minus withdrawals) as bigint; latestFirst reverses to newest-first.
export function calculateActivityContributions(
    items: LendVaultActivityItem[],
    latestFirst = false
): LendVaultActivityItemWithContribution[] {
    const chronological = [...items].sort((a, b) => a.timestamp - b.timestamp);
    let runningContribution = 0n;
    const mapped = chronological.map((item) => {
        runningContribution += item.actionType === VaultActionType.Withdrawal ? -item.amount : item.amount;
        return { ...item, contribution: runningContribution };
    });
    return latestFirst ? mapped.reverse() : mapped;
}
